'use client';

interface FilterOption<T = string> {
  label: string;
  value: T;
}

interface FilterSelectProps<T extends string = string> {
  value: T | '';
  onChange: (value: T | '') => void;
  options: FilterOption<T>[];
  placeholder?: string;
  className?: string;
}

export default function FilterSelect<T extends string = string>({
  value,
  onChange,
  options,
  placeholder = 'Todos',
  className = '',
}: FilterSelectProps<T>) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as T | '')}
      // Tokens do design system (dark-mode aware + WCAG AA). color-scheme faz o
      // dropdown nativo seguir o tema; bg/text nos options cobrem navegadores
      // que respeitam o estilo (Chromium/Firefox).
      className={`rounded border border-[var(--border)] bg-[var(--bg-card)] px-3 py-2 text-sm text-[var(--fg)] outline-none [color-scheme:light_dark] focus:border-[var(--brand-500)] focus:ring-2 focus:ring-[var(--brand-600)]/30 ${className}`}
    >
      <option value="" className="bg-[var(--bg-card)] text-[var(--fg)]">{placeholder}</option>
      {options.map((o) => (
        <option key={o.value} value={o.value} className="bg-[var(--bg-card)] text-[var(--fg)]">
          {o.label}
        </option>
      ))}
    </select>
  );
}
